"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textFillColors = exports.textOnColors = exports.textColors = exports.strokeColors = exports.iconFillColors = exports.iconColors = exports.borderColors = exports.backgroundStateActiveColors = exports.backgroundStateColors = exports.backgroundColors = void 0;
var classnames_1 = require("classnames");
exports.backgroundColors = {
    victor: {
        primary: (0, classnames_1.default)('squid-bg-alias-color-victor-bg-primary'),
        'accent-weak': (0, classnames_1.default)('squid-bg-alias-color-victor-bg-accent-weak'),
    },
    base: {
        transparent: (0, classnames_1.default)('squid-bg-transparent'),
        base: (0, classnames_1.default)('squid-bg-alias-color-bg-base'),
        'base-inverse': (0, classnames_1.default)('squid-bg-alias-color-bg-base-inverse'),
        disabled: (0, classnames_1.default)('squid-bg-alias-color-bg-disabled'),
        neutral: (0, classnames_1.default)('squid-bg-alias-color-bg-neutral'),
        alt: (0, classnames_1.default)('squid-bg-alias-color-bg-alt'),
        accent: (0, classnames_1.default)('squid-bg-alias-color-bg-accent'),
        'accent-weak': (0, classnames_1.default)('squid-bg-alias-color-bg-accent-weak'),
        primary: (0, classnames_1.default)('squid-bg-alias-color-bg-primary'),
        'primary-weak': (0, classnames_1.default)('squid-bg-alias-color-bg-primary-weak'),
        secondary: (0, classnames_1.default)('squid-bg-alias-color-bg-secondary'),
        tertiary: (0, classnames_1.default)('squid-bg-alias-color-bg-tertiary'),
        attention: (0, classnames_1.default)('squid-bg-alias-color-bg-attention'),
        'attention-weak': (0, classnames_1.default)('squid-bg-alias-color-bg-attention-weak'),
        critical: (0, classnames_1.default)('squid-bg-alias-color-bg-critical'),
        'critical-weak': (0, classnames_1.default)('squid-bg-alias-color-bg-critical-weak'),
        success: (0, classnames_1.default)('squid-bg-alias-color-bg-success'),
        'success-weak': (0, classnames_1.default)('squid-bg-alias-color-bg-success-weak'),
        info: (0, classnames_1.default)('squid-bg-alias-color-bg-info'),
        'info-weak': (0, classnames_1.default)('squid-bg-alias-color-bg-info-weak'),
    },
};
exports.backgroundStateColors = {
    victor: {
        primary: (0, classnames_1.default)('hover:squid-bg-alias-state-victor-primary-hover active:squid-bg-alias-state-victor-primary-pressed'),
    },
    base: {
        base: (0, classnames_1.default)('hover:squid-bg-alias-state-base-hover active:squid-bg-alias-state-base-pressed'),
        primary: (0, classnames_1.default)('hover:squid-bg-alias-state-primary-hover active:squid-bg-alias-state-primary-pressed'),
        secondary: (0, classnames_1.default)('hover:squid-bg-alias-state-secondary-hover active:squid-bg-alias-state-secondary-pressed'),
        tertiary: (0, classnames_1.default)('hover:squid-bg-alias-state-tertiary-hover active:squid-bg-alias-state-tertiary-pressed'),
        success: (0, classnames_1.default)('hover:squid-bg-alias-state-success-hover active:squid-bg-alias-state-success-pressed'),
        destructive: (0, classnames_1.default)('hover:squid-bg-alias-state-destructive-hover active:squid-bg-alias-state-destructive-pressed'),
    },
};
exports.backgroundStateActiveColors = {
    victor: {
        primary: 'squid-bg-alias-state-victor-primary-active',
    },
    base: {
        base: 'squid-bg-alias-state-base-active',
        primary: 'squid-bg-alias-state-victor-primary-active',
        secondary: 'squid-bg-alias-state-secondary-active',
        tertiary: 'squid-bg-alias-state-tertiary-active',
        success: 'squid-bg-alias-state-success-active',
        destructive: 'squid-bg-alias-state-destructive-active',
    },
};
exports.borderColors = {
    victor: {},
    base: {
        base: (0, classnames_1.default)('squid-border-alias-color-border-base'),
        'base-inverse': (0, classnames_1.default)('squid-border-alias-color-border-base-inverse'),
        disabled: (0, classnames_1.default)('squid-border-alias-color-border-disabled'),
        accent: (0, classnames_1.default)('squid-border-alias-color-border-accent'),
        active: (0, classnames_1.default)('squid-border-alias-color-border-active'),
        'active-inverse': (0, classnames_1.default)('squid-border-alias-color-border-active-inverse'),
        pressed: (0, classnames_1.default)('squid-border-alias-color-border-pressed'),
        hover: (0, classnames_1.default)('squid-border-alias-color-border-hover'),
        critical: (0, classnames_1.default)('squid-border-alias-color-border-critical'),
        weak: (0, classnames_1.default)('squid-border-alias-color-border-weak'),
        'weak-inverse': (0, classnames_1.default)('squid-border-alias-color-border-weak-inverse'),
    },
};
exports.iconColors = {
    victor: {
        accent: (0, classnames_1.default)('squid-text-alias-color-victor-icon-accent'),
    },
    base: {
        base: (0, classnames_1.default)('squid-text-alias-color-icon-base'),
        disabled: (0, classnames_1.default)('squid-text-alias-color-icon-disabled'),
        accent: (0, classnames_1.default)('squid-text-alias-color-icon-accent'),
        primary: (0, classnames_1.default)('squid-text-alias-color-icon-primary'),
        attention: (0, classnames_1.default)('squid-text-alias-color-icon-attention'),
        critical: (0, classnames_1.default)('squid-text-alias-color-icon-critical'),
        success: (0, classnames_1.default)('squid-text-alias-color-icon-success'),
        info: (0, classnames_1.default)('squid-text-alias-color-icon-info'),
    },
};
exports.iconFillColors = {
    victor: {},
    base: {
        base: (0, classnames_1.default)('squid-fill-alias-color-icon-base'),
        disabled: (0, classnames_1.default)('squid-fill-alias-color-icon-disabled'),
        accent: (0, classnames_1.default)('squid-fill-alias-color-icon-accent'),
        primary: (0, classnames_1.default)('squid-fill-alias-color-icon-primary'),
        attention: (0, classnames_1.default)('squid-fill-alias-color-icon-attention'),
        critical: (0, classnames_1.default)('squid-fill-alias-color-icon-critical'),
        success: (0, classnames_1.default)('squid-fill-alias-color-icon-success'),
        info: (0, classnames_1.default)('squid-fill-alias-color-icon-info'),
    },
};
exports.strokeColors = {
    victor: {
        primary: (0, classnames_1.default)('squid-stroke-alias-color-victor-bg-primary'),
        'accent-weak': (0, classnames_1.default)('squid-stroke-alias-color-victor-bg-accent-weak'),
    },
    base: {
        transparent: (0, classnames_1.default)('squid-stroke-transparent'),
        base: (0, classnames_1.default)('squid-stroke-alias-color-bg-base'),
        'base-inverse': (0, classnames_1.default)('squid-stroke-alias-color-bg-base-inverse'),
        disabled: (0, classnames_1.default)('squid-stroke-alias-color-bg-disabled'),
        neutral: (0, classnames_1.default)('squid-stroke-alias-color-bg-neutral'),
        alt: (0, classnames_1.default)('squid-stroke-alias-color-bg-alt'),
        accent: (0, classnames_1.default)('squid-stroke-alias-color-bg-accent'),
        'accent-weak': (0, classnames_1.default)('squid-stroke-alias-color-bg-accent-weak'),
        primary: (0, classnames_1.default)('squid-stroke-alias-color-bg-primary'),
        'primary-weak': (0, classnames_1.default)('squid-stroke-alias-color-bg-primary-weak'),
        secondary: (0, classnames_1.default)('squid-stroke-alias-color-bg-secondary'),
        tertiary: (0, classnames_1.default)('squid-stroke-alias-color-bg-tertiary'),
        attention: (0, classnames_1.default)('squid-stroke-alias-color-bg-attention'),
        'attention-weak': (0, classnames_1.default)('squid-stroke-alias-color-bg-attention-weak'),
        critical: (0, classnames_1.default)('squid-stroke-alias-color-bg-critical'),
        'critical-weak': (0, classnames_1.default)('squid-stroke-alias-color-bg-critical-weak'),
        success: (0, classnames_1.default)('squid-stroke-alias-color-bg-success'),
        'success-weak': (0, classnames_1.default)('squid-stroke-alias-color-bg-success-weak'),
        info: (0, classnames_1.default)('squid-stroke-alias-color-bg-info'),
        'info-weak': (0, classnames_1.default)('squid-stroke-alias-color-bg-info-weak'),
    },
};
exports.textColors = {
    victor: {},
    base: {
        base: (0, classnames_1.default)('squid-text-alias-color-text-base'),
        weak: (0, classnames_1.default)('squid-text-alias-color-text-weak'),
        weaker: (0, classnames_1.default)('squid-text-alias-color-text-weaker'),
        weakest: (0, classnames_1.default)('squid-text-alias-color-text-weakest'),
        info: (0, classnames_1.default)('squid-text-alias-color-text-info'),
        attention: (0, classnames_1.default)('squid-text-alias-color-text-attention'),
        critical: (0, classnames_1.default)('squid-text-alias-color-text-critical'),
        success: (0, classnames_1.default)('squid-text-alias-color-text-success'),
        disabled: (0, classnames_1.default)('squid-text-alias-color-text-disabled'),
        accent: (0, classnames_1.default)('squid-text-alias-color-text-accent'),
        'link-default': (0, classnames_1.default)('squid-text-alias-color-text-link-default'),
        'link-hover': (0, classnames_1.default)('squid-text-alias-color-text-link-hover'),
        'link-pressed': (0, classnames_1.default)('squid-text-alias-color-text-link-pressed'),
        'link-visited': (0, classnames_1.default)('squid-text-alias-color-text-link-visited'),
    },
};
exports.textOnColors = {
    victor: {},
    base: {
        'on-destructive': (0, classnames_1.default)('squid-text-alias-color-text-on-destructive'),
        'on-critical': (0, classnames_1.default)('squid-text-alias-color-text-on-critical'),
        'on-critical-weak': (0, classnames_1.default)('squid-text-alias-color-text-on-critical-weak'),
        'on-base-active': (0, classnames_1.default)('squid-text-alias-color-text-on-base-active'),
        'on-base-inverse': (0, classnames_1.default)('squid-text-alias-color-text-on-base-inverse'),
        'on-accent': (0, classnames_1.default)('squid-text-alias-color-text-on-accent'),
        'on-attention': (0, classnames_1.default)('squid-text-alias-color-text-on-attention'),
        'on-attention-weak': (0, classnames_1.default)('squid-text-alias-color-text-on-attention-weak'),
        'on-outline': (0, classnames_1.default)('squid-text-alias-color-text-on-outline'),
        'on-outline-active': (0, classnames_1.default)('squid-text-alias-color-text-on-outline-active'),
        'on-neutral': (0, classnames_1.default)('squid-text-alias-color-text-on-neutral'),
        'on-primary': (0, classnames_1.default)('squid-text-alias-color-text-on-primary'),
        'on-primary-variant': (0, classnames_1.default)('squid-text-alias-color-text-on-primary-variant'),
        'on-secondary': (0, classnames_1.default)('squid-text-alias-color-text-on-secondary'),
        'on-tertiary': (0, classnames_1.default)('squid-text-alias-color-text-on-tertiary'),
        'on-success': (0, classnames_1.default)('squid-text-alias-color-text-on-success'),
        'on-success-weak': (0, classnames_1.default)('squid-text-alias-color-text-on-success-weak'),
        'on-info': (0, classnames_1.default)('squid-text-alias-color-text-on-info'),
        'on-info-weak': (0, classnames_1.default)('squid-text-alias-color-text-on-info-weak'),
    },
};
exports.textFillColors = {
    victor: {},
    base: {
        base: (0, classnames_1.default)('squid-fill-alias-color-text-base'),
        weak: (0, classnames_1.default)('squid-fill-alias-color-text-weak'),
        weaker: (0, classnames_1.default)('squid-fill-alias-color-text-weaker'),
        weakest: (0, classnames_1.default)('squid-fill-alias-color-text-weakest'),
        info: (0, classnames_1.default)('squid-fill-alias-color-text-info'),
        critical: (0, classnames_1.default)('squid-fill-alias-color-text-critical'),
        success: (0, classnames_1.default)('squid-fill-alias-color-text-success'),
        disabled: (0, classnames_1.default)('squid-fill-alias-color-text-disabled'),
        accent: (0, classnames_1.default)('squid-fill-alias-color-text-accent'),
        'link-default': (0, classnames_1.default)('squid-fill-alias-color-text-link-default'),
        'link-hover': (0, classnames_1.default)('squid-fill-alias-color-text-link-hover'),
        'link-pressed': (0, classnames_1.default)('squid-fill-alias-color-text-link-pressed'),
        'link-visited': (0, classnames_1.default)('squid-fill-alias-color-text-link-visited'),
    },
};
